import z from "zod";

export const fileSchema = z.object({
  name: z.string(),
  size: z.number(),
  lastModified: z.coerce.date(),
});

export const folderSchema = z.object({
  name: z.string(),
});

export const fileObjectSchema = z.discriminatedUnion("type", [
  fileSchema.extend({ type: z.literal("file") }),
  folderSchema.extend({ type: z.literal("folder") }),
]);

export type fileObject = z.infer<typeof fileObjectSchema>;
